module.exports = __webpack_public_path__ + "assets/convertkit.3211219d.svg";